import request from '@/http/request'

export const getOutboundScanDropList = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelV/searchParams`)
}

export const getOutboundSacnQuerySummary = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelV/summary`, params)
}

export const getOutboundSacnQuerySummaryDownload = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelV/summary/download`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const getOutboundSacnQueryDetail = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelV/detail`, params)
}

export const getOutboundSacnQueryDetailDownload = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelV/detail/download`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
export const getExceptionDownload = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/tunnelV/exception/download`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
